import classnames from "classnames";
import {ReactNode} from "react";
import {IconType} from "react-icons";
import {FaInfo} from "react-icons/fa6";

import styles from "./FeatureBlock.module.css";

export interface FeatureBlockProps {
  title: string;
  subtitle: string;
  icon: IconType;
  accessory: ReactNode;
  supportURL?: string;
}

export const FeatureBlock = ({title, subtitle, icon, supportURL, accessory}: FeatureBlockProps) => {
  const Icon = icon;
  return (
    <div className={classnames("border border-1 border-success-hover rounded-2 p-3", styles.featureBlock)}>
      <span className="d-flex align-items-center">
        <Icon size="1rem" />
        <span className="ms-2 me-1 fs-6">{title}</span>
        {supportURL && (
          <a className="d-flex align-items-center" target="_blank" href={supportURL}>
            <FaInfo size="0.75rem" />
          </a>
        )}
      </span>
      <div className="mt-2">
        <small className="text-muted">{subtitle}</small>
      </div>
      <div className={styles.accessory}>{accessory}</div>
    </div>
  );
};
